import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import axiosInstance from "../../utils/axiosInstance";
import "./orderdetails.css"
import { TbTruckDelivery } from 'react-icons/tb';
import { FaFileDownload } from 'react-icons/fa';
import { IoArrowBack } from "react-icons/io5";
import { FiUser } from "react-icons/fi";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearWishlist } from "../../redux/wishlistSlice";

function OrderDetails({ orderIdProp, typeProp, rentalIdProp, addressIdProp, onBack }) {
    let [searchParams] = useSearchParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [orderData, setOrderData] = useState([]);
    const [addressData, setAddressdata] = useState();
    const [lodaing, setLoading] = useState(false);
    const orderId = orderIdProp || searchParams.get("orderID") || searchParams.get("orderId");
    const type = typeProp || searchParams.get("type");
    const rentalId = rentalIdProp || searchParams.get("rental_id") || searchParams.get("rentalId");
    const addressId = addressIdProp || searchParams.get("address") || searchParams.get("address_id");
    const userName = localStorage.getItem("name") || "Customer";
    const logout = () => {
        ["token", "userid", "name", "store_id", "defaultAddress", "defaultAddressId", "saleAddress", "rentalAddress", "verifiedZipcode", "savedZipcode"].forEach((key) => localStorage.removeItem(key));
        dispatch(clearWishlist());
        window.dispatchEvent(new Event("authChange"));
        toast.success("Logged out");
        navigate("/");
    };
    const formatPrice = (price) =>
        price?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            // minimumFractionDigits: 0,
            // maximumFractionDigits: 0,
        }).replace("$", "$ ");
    const formatDateOnly = (val) => {
        if (!val) return null;
        const d = new Date(val);
        if (isNaN(d.getTime())) return val;
        return d.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };
    async function fetchAddress(id) {
        const targetId = id || addressId;
        if (!targetId) return;
        try {
            const response = await axiosInstance(`/accounts/address/${targetId}/`)
            setAddressdata(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        if (!orderId || !type) {
            if (!orderIdProp) navigate("/account/orders");
            return;
        }
        async function fetchOrderData() {
            setLoading(true)
            try {
                const rentalParam =
                    type === "rental" ? `&rental_order_id=${rentalId || ""}` : "";

                const res = await axiosInstance(`/accounts/orderdetails/?order=${orderId}&item_type=${type}${rentalParam}`)
                const results = res?.data?.results || [];
                setOrderData(results)
                if (!addressId && results.length > 0) {
                    const firstObj = results[0];
                    const derivedAddr = firstObj?.order?.address_id || firstObj?.order?.address || firstObj?.address_id || firstObj?.address || firstObj?.order?.rental_addresses?.id || firstObj?.order?.sale_addresses?.id || firstObj?.order?.rental_addresses || firstObj?.order?.sale_addresses;
                    if (derivedAddr) {
                        fetchAddress(derivedAddr);
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        fetchOrderData()
        if (addressId) {
            fetchAddress(addressId)
        }
    }, [rentalId, type, orderId, navigate, orderIdProp, addressId])
    const rentalItems = orderData.filter(item => item.item_type === "rental");
    const saleItems = orderData.filter(item => item.item_type === "sale");
    const saleDeliveryCharge =
        orderData.length > 0
            ? Number(orderData[0]?.order?.sale_delivery_charges || 0)
            : 0;

    const saleTotalWithDelivery =
        saleItems.reduce(
            (sum, item) => sum + Number(item?.net_amount || 0),
            0
        );

    const rentDeliveryCharge =
        orderData.length > 0
            ? Number(orderData[0]?.order?.rental_delivery_charges || 0)
            : 0;
    const rentTotalWithDelivery =
        rentalItems.reduce(
            (sum, item) =>
                sum + Number(item?.net_amount || 0),
            0
        );
    const invoiceStatus = orderData[0]?.order?.invoice_status;
    async function handlePrint(id) {
        try {
            const res = await axiosInstance(`/accounts/pdf/${id}/`, { responseType: "blob" })
            const file = new Blob([res.data], { type: "application/pdf" })
            const fileUrl = URL.createObjectURL(file)
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', `Invoice_${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.log(error)
            alert("pdf not available")
        }
    }
    const content = (
        <>
            {
                lodaing ? <div className='spinner-container'><div className='modern-spinner'></div></div> :
                    (
                        <div>
                            <div className="order-details-wrapper">
                                <button
                                    type="button"
                                    className="order-back-button"
                                    onClick={onBack || (() => navigate("/account/orders"))}
                                >
                                    <IoArrowBack /> Back to Orders
                                </button>
                                <div className="order-details-topbar">
                                    <div className="order-summary-meta">
                                        <h4 className='mb-0'>{orderData.length} item{orderData.length > 1 ? "s" : ""}</h4>
                                        <div className="order-meta-row">
                                            <h4 className='mb-0'>
                                                Order Id: {orderData[0]?.display_order_id || orderId}
                                            </h4>
                                            {invoiceStatus === "Rejected" && (
                                                <span className="invoice-status-badge rejected">Invoice Rejected</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <button className="btn btn-sm d-flex align-items-center gap-2" style={{ backgroundColor: "#fe7900", color: "white", border: "none" }} onClick={() => handlePrint(orderId)}>
                                            <FaFileDownload /> Download Invoice
                                        </button>
                                    </div>
                                </div>
                                {orderData.map((item) => {
                                    const statusText = item?.order?.orderstatus || item?.status || "Placed";
                                    const amountVal = Number(item?.net_amount ?? item?.total_price ?? item?.offer_price ?? item?.price ?? 0);
                                    const qtyVal = item?.quantity ?? item?.qty ?? 1;
                                    const startDateVal = formatDateOnly(item?.rental_start_date || item?.start_date);
                                    const endDateVal = formatDateOnly(item?.rental_end_date || item?.end_date);

                                    return (
                                        <div className="order-item-card" key={item.id}>
                                            <div className="order-item-image">
                                                <img
                                                    src={item?.varient?.images?.[0]?.image?.image || "/placeholder.png"}
                                                    alt={item.varient?.name || "Product"}
                                                />
                                            </div>

                                            <div className="order-item-details">
                                                <h4 className="order-item-title">{item.varient?.name}</h4>

                                                {item.varient?.options?.length > 0 && (
                                                    <div className="variant-details-list">
                                                        {item.varient.options.map((option) => (
                                                            <div className="variant-row" key={option.id}>
                                                                <span className="variant-label">{option.variant_type}</span>
                                                                <span className="variant-value">{option.variant_option}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="order-item-meta">
                                                <div className="meta-row">
                                                    <span className="meta-label">Status</span>
                                                    <span className="meta-value status-pill">{statusText}</span>
                                                </div>
                                                <div className="meta-row">
                                                    <span className="meta-label">Payment Mode</span>
                                                    <span className="meta-value">
                                                        {(() => {
                                                            const rawMode = (item?.order?.payment_mode || item?.payment_mode || "").toLowerCase();
                                                            if (rawMode === "cash") return "Cash on Delivery";
                                                            if (rawMode === "online") return "Online";
                                                            return item?.order?.payment_mode || item?.payment_mode || "-";
                                                        })()}
                                                    </span>
                                                </div>
                                                <div className="meta-row">
                                                    <span className="meta-label">Total Amount</span>
                                                    <span className="meta-value price-val">{formatPrice(amountVal)}</span>
                                                </div>
                                                <div className="meta-row">
                                                    <span className="meta-label">Quantity</span>
                                                    <span className="meta-value">{qtyVal}</span>
                                                </div>
                                                {startDateVal && (
                                                    <div className="meta-row">
                                                        <span className="meta-label">Start Date</span>
                                                        <span className="meta-value">{startDateVal}</span>
                                                    </div>
                                                )}
                                                {endDateVal && (
                                                    <div className="meta-row">
                                                        <span className="meta-label">End Date</span>
                                                        <span className="meta-value">{endDateVal}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="price-breakup-section">
                                {rentalItems.length > 0 && (
                                    <div className="breakup-background2">
                                        <div className="break-header">
                                            <h4>Rent Cost Breakup</h4>
                                        </div>

                                        <div className="data-container-parent">
                                            {rentalItems.map((item) => {
                                                const basePrice = Number(
                                                    item?.price ??
                                                    item?.varient?.prices?.rental_price ??
                                                    item?.varient?.product?.rental_price ??
                                                    item?.rental_price ??
                                                    0
                                                );

                                                // Prefer the per-unit offer price from the variant prices
                                                const rentalOfferPrice = Number(
                                                    item?.varient?.prices?.rental_offer_price ??
                                                    item?.offer_price ??
                                                    basePrice
                                                );

                                                const qty = Number(item.quantity ?? 0);

                                                const duration = Number(
                                                    item.rental_duration ?? 1
                                                );

                                                const rentalBaseTotal =
                                                    basePrice * duration * qty;

                                                // Discount = (rental_price - rental_offer_price) × qty × duration
                                                const rentalDiscount =
                                                    Math.max(basePrice - rentalOfferPrice, 0) *
                                                    qty *
                                                    duration;

                                                const couponDiscount = Number(
                                                    item?.rental_coupon_discount || 0
                                                );

                                                const deliveryCharges = Number(
                                                    item?.delivery_charges || 0
                                                );

                                                const finalNetAmount = Number(
                                                    item?.net_amount || 0
                                                );
                                                return (
                                                    <div className="data-container" key={item.id}>
                                                        <div className="break-item-title">
                                                            {item.varient?.name} × {qty}
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(A) Base Rental Cost</div>
                                                            <div>
                                                                {formatPrice(basePrice)}/
                                                                {item.package === "Monthly"
                                                                    ? "Month"
                                                                    : item.package === "Daily"
                                                                        ? "Day"
                                                                        : "Week"}
                                                            </div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(B) Duration</div>
                                                            <div>
                                                                {duration}{" "}
                                                                {item.package === "Monthly"
                                                                    ? duration === 1 ? "Month" : "Months"
                                                                    : item.package === "Daily"
                                                                        ? duration === 1 ? "Day" : "Days"
                                                                        : duration === 1 ? "Week" : "Weeks"}
                                                            </div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(C) Quantity</div>
                                                            <div>{qty} Qty</div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(D) Total Price (A × B × C)</div>
                                                            <div>{formatPrice(rentalBaseTotal)}</div>
                                                        </div>

                                                        <div className="breakup-item text-success">
                                                            <div>(E) Rental Discount</div>
                                                            <div>
                                                                {(() => {
                                                                    // Prefer computed % from price fields; fall back to API field
                                                                    const pct = basePrice > 0
                                                                        ? parseFloat(((basePrice - rentalOfferPrice) / basePrice * 100).toFixed(2))
                                                                        : parseFloat(Number(item.discount_percentage || 0).toFixed(2));
                                                                    return pct > 0 ? `-${pct}% ` : "";
                                                                })()}
                                                                -{formatPrice(rentalDiscount)}
                                                            </div>
                                                        </div>
                                                        {/* <div className="breakup-item text-success">
                                                          <div>(F) Rental Coupon Discount</div>
                                                            <div>-{formatPrice(couponDiscount)}</div>
                                                        </div> */}
                                                        <div className="breakup-item">
                                                            <div>(F) Delivery Charges</div>
                                                            <div>
                                                                {item?.order?.delivery_type === "Self"
                                                                    ? "Self Pickup"
                                                                    : formatPrice(item.delivery_charges)}
                                                            </div>
                                                        </div>
                                                        <div className="breakup-item">
                                                            <div>Net Amount</div>
                                                            <div>{formatPrice(finalNetAmount)}</div>
                                                        </div>
                                                        {/* <div className="discount-green">
                                                            You Will Save{" "}
                                                            {formatPrice(
                                                                rentalDiscount + couponDiscount
                                                            )}
                                                        </div> */}
                                                    </div>

                                                );
                                            })}

                                            <div className="breakup-item breakup-total breakup-rental-total">
                                                <div className="breakup-total-label breakup-rental-label">
                                                    Rental Total
                                                </div>
                                                <div className="breakup-total-value breakup-rental-value">
                                                    {formatPrice(rentTotalWithDelivery)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {saleItems.length > 0 && (
                                    <div className="breakup-background2">
                                        <div className="break-header">
                                            <h4>Buy Cost Breakup</h4>
                                        </div>

                                        <div className="data-container-parent">
                                            {saleItems.map((item) => {
                                                const price = Number(item.price);
                                                const offerPrice = Number(item.offer_price);
                                                const qty = Number(item.quantity);
                                                const couponDiscount = Number(item.sale_coupon_discount || 0);
                                                const deliveryCharge = Number(item.delivery_charges || 0);
                                                const netPrice = (offerPrice * qty) - couponDiscount;

                                                return (
                                                    <div className="data-container" key={item.id}>
                                                        <div className="break-item-title">
                                                            {item.varient?.name} × {qty}
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(A) Base Sale Cost</div>
                                                            <div>{formatPrice(price)}</div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(B) Quantity</div>
                                                            <div>{qty} Qty</div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(C) Total Price</div>
                                                            <div>{formatPrice(price * qty)}</div>
                                                        </div>

                                                        <div className="breakup-item text-success">
                                                            <div>(D) Sale Discount</div>
                                                            <div>
                                                                -{formatPrice((price * qty) - (offerPrice * qty))}
                                                            </div>
                                                        </div>
                                                        <div className="breakup-item text-success">
                                                            <div>(E) Coupon Discount</div>
                                                            <div>-{formatPrice(couponDiscount)}</div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>(F) Delivery Charges</div>
                                                            <div>
                                                                {item?.order?.delivery_type === "Self"
                                                                    ? "Self Pickup"
                                                                    : formatPrice(deliveryCharge)}
                                                            </div>
                                                        </div>

                                                        <div className="breakup-item">
                                                            <div>Net Amount</div>
                                                            <div>{formatPrice(netPrice)}</div>
                                                        </div>

                                                    </div>
                                                );
                                            })}

                                            <div className="breakup-item breakup-total breakup-sale-total">
                                                <div className="breakup-total-label breakup-sale-label">
                                                    Sale Total
                                                </div>
                                                <div className="breakup-total-value breakup-sale-value">
                                                    {formatPrice(saleTotalWithDelivery)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                            {addressData && (
                                <div className="delivery-address-card">
                                    <div className="delivery-header">
                                        <span className="address-icon"><TbTruckDelivery /></span>
                                        <span className="delivery-title">Delivery Address</span>
                                    </div>

                                    <div className="delivery-body">
                                        <div className="address-row">
                                            <span className="label">Name:</span>
                                            <span className="value">{addressData.name}</span>
                                        </div>

                                        <div className="address-row">
                                            <span className="label">Phone number:</span>
                                            <span className="value">{addressData.mobileno}</span>
                                        </div>

                                        <div className="address-row">
                                            <span className="label">Payment Mode:</span>
                                            <span className="value">
                                                {(() => {
                                                    const rawMode = (orderData[0]?.order?.payment_mode || "").toLowerCase();
                                                    if (rawMode === "cash") return "Cash on Delivery";
                                                    if (rawMode === "online") return "Online";
                                                    return orderData[0]?.order?.payment_mode || "-";
                                                })()}
                                            </span>
                                        </div>

                                        <div className="address-row">
                                            <span className="label">Address:</span>
                                            <span className="value">
                                                {addressData.flat_no}, {addressData.address_line_1},{" "}
                                                {addressData.address_line_2}, {addressData.city},{" "}
                                                {addressData.state} {addressData.zipcode},{" "}
                                                {addressData.country}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>

                    )
            }

        </>
    );

    if (onBack) {
        return content;
    }

    return (
        <main className="account-page">
            <div className="account-shell">
                <aside className="account-sidebar">
                    <p style={{ display: "flex", alignItems: "center", gap: "6px" }}><FiUser size={14} /> Account</p>
                    <strong>{userName}</strong>
                    <button className="active" type="button" onClick={() => navigate("/account/orders")}>Orders</button>
                    <button type="button" onClick={() => navigate("/address")}>Address</button>
                    <button type="button" onClick={() => navigate("/wishlist")}>Wishlist</button>
                    <button type="button" className="logout-btn" onClick={logout}>Logout</button>
                </aside>
                <section className="account-content">
                    {content}
                </section>
            </div>
        </main>
    )
}

export default OrderDetails
